import React from "react";
import { Redirect, Link } from "react-router-dom";
import { ProgramacaoNavios } from "./modules/programacao/containers/ProgramacaoNavios";
import { Containers } from "./modules/consultas/containers/tela/Containers";
import { ContainersDetalhes } from "./modules/consultas/containers/tela/ContainersDetalhes";
import { Booking } from "./modules/consultas/booking/tela/Booking";
import {
  Bandeiras,
  Programacao,
  IconeFlag,
  Liberacoes,
  IconeGenerico
} from "../src/modules/comum/components/Icones";
import { AgendamentoDashboard } from "./modules/agendamento/dashboard/tela/AgendamentoDashboard";
import { Agendamento } from "./modules/agendamento/containers-visualizar/tela/Agendamento";
import { AgendamentoCadastrar } from "./modules/agendamento/containers-cadastrar/telas/AgendamentoCadastrar";
import { UnidadesLiberadasArmador } from "./modules/agendamento/depot-unidades-liberadas/telas/UnidadesLiberadasArmador";
import { Triagem } from "./modules/agendamento/depot-triagem/tela/Triagem";
import { AgendamentoNotaFiscal } from "./modules/agendamento/nota-fiscal-visualizar/tela/AgendamentoNotaFiscal";
import { NotaFiscalCadastrar } from "./modules/agendamento/nota-fiscal-cadastrar/tela/NotaFiscalCadastrar";
import { EntradaAntecipada } from "./modules/agendamento/entrada-antecipada/telas/EntradaAntecipada"
import { Login } from "./modules/login/tela/Login";
import { SailingBreakdown } from "./modules/consultas/sailing-breakdown/tela/SailingBreakdown";
import { Movimentacao } from "./modules/consultas/movimentação/tela/Movimentacao";
import { Importacao } from "./modules/liberacoes/importacao/telas/Importacao";
import { ImportacaoDetalhes } from "./modules/liberacoes/importacao/components/ImportacaoDetalhes";
import { Cabotagem } from './modules/liberacoes/cabotagem/telas/Cabotagem';
import { AnaliseCritica } from './modules/analise/tela/AnaliseCritica';
import { DirecionamentoTecon } from './modules/direcionamento/tecon/telas/DirecionamentoTecon'
import { BloqueioBl } from './modules/bloqueiobl/telas/BloqueioBl'
import { Acompanhamento } from './modules/acompanhamento/telas/Acompanhamento';
import { AcompanhamentoServicos } from "./modules/acompanhamentoservico/telas/AcompanhamentoServicos";
import { Osweb } from "./modules/osweb/telas/OSWeb";
import ConsultaEdiNf from "./modules/nota-fiscal-transporte/edi/telas/ConsultaEdiNf";
import { AgServicos } from "./modules/agendamentoservicos/agservicos/AgServicos";
import { AgServicosTotal } from "./modules/agendamentoservicosTotal/agservicos/AgServicos";
import { NotaFiscalFaturamento } from "./modules/faturamento/notafiscal/tela/NotaFiscalFaturamento";
import { VeiculosCDTA } from './modules/veiculoscdta/telas/VeiculosCDTA';
import { Veiculos } from './modules/veiculos/telas/Veiculos';
import { RelatorioSintetico } from './modules/entrepostagem/relatoriosintetico/telas/RelatorioSintetico';
import { RelatorioAnalitico } from './modules/entrepostagem/relatorioanalitico/telas/RelatorioAnalitico';
import { BookingDepot } from "./modules/bookingdepot/telas/BookingDepot";
import { DirecionamentoRecinto } from "./modules/direcionamento/recinto/telas/DirecionamentoRecinto";
import AgendVgm from "./modules/agend-vgm/telas/AgendVgm";
import { ControleAcesso } from "./modules/controleacesso/telas/ControleAcesso";
import { ConsultaOrcamento } from "./modules/faturamento/consulta/telas/ConsultaOrcamento";
import { AlteraDtaDtc } from "./modules/faturamento/dtadtc/telas/AlteraDtaDtc";
import MeuTecon from "./modules/meutecon/telas/MeuTecon";
import Notices from "./modules/notices/telas/Notices";
import FormNotice from "./modules/notices/components/FormNotice";
import { ConsultaVeiculos } from "./modules/consultas/veiculos/telas/ConsultaVeiculos";
import { ControleEstoque } from "./modules/consultas/estoque/telas/ControleEstoque";
import { CargaPatioDTC } from "./modules/agendamento/cargapatiodtc/telas/CargaPatioDTC";
import DesovaPier from './modules/desova-pier/telas/DesovaPier';
import { TriagemDepot } from "./modules/consultas/triagem-depot/telas/TriagemDepot";
import { CargaGeral } from "./modules/carga-geral/telas/cargaGeral";
import { CargaGeralAcompanhamento } from "./modules/carga-geral/telas/CargaGeralAcompanhamento";
import { SimulacaoServicos } from "./modules/simulacao-servicos/telas/SimulacaoServicos";
class Routes {
  
  constructor() {
    const menuIconColor = "#00BEDD";
    this.data = [
      {
        separator: true,
        label: "Programação de Navios",
        tag: "ProgramacaoNavios",
        permission: [],
        needLogin: false,
        icon: <div style={{ fontSize: "14px" }}><IconeGenerico icone="ship" tamanho="lg" className="icon" /></div>,
        itens: [
          {
            tag: "ProgramacaoNavios",
            path: "/programacao-navios",
            component: ProgramacaoNavios,
            onSideBar: false
          },
          {
            tag: "ProgramacaoNavios",
            path: "/",
            component: ProgramacaoNavios,
            onSideBar: false
          },
          {
            /*TODO: separar para área que não aparece no sidebar*/
            tag: "Login",
            path: "/login",
            component: Login,
            onSideBar: false
          },
          {
            tag: "ControleAcesso",
            path: "/controle-acesso",
            component: ControleAcesso,
            onSideBar: false
          }
        ]
      },
      {
        separator: true,
        label: "Simule um serviço",
        tag: "SimulacaoServico",
        permission: [],
        needLogin: false,
        icon: <div style={{ fontSize: "14px" }}><IconeGenerico icone="calculator" tamanho="lg" className="icon" /></div>,
        itens: [
          {
            tag: "SimulacaoServico",
            path: "/simulacao-servicos",
            component: SimulacaoServicos,
            onSideBar: false,
            exact: true,
          }
        ]
      },  
      {
        separator: true,
        label: "Carga Pátio e DTC",
        tag: "CargaPatioDtcB2B",
        permission: [],
        terminalVisibility: ["RIG"],
        needLogin: true,
        icon: <div style={{ fontSize: "14px" }}><IconeGenerico icone="file-alt" tamanho="lg" className="icon"  /></div>,
        itens: [
          {
            label: "Solicitações",
            tag: "CargaPatioDtcB2B",
            path: "/cargapatiodtc",
            component: CargaPatioDTC,
            needLogin: true,
            onSideBar: true
          }
        ]
      },
      {
        separador: true,
        label: "Desova Pier",
        tag: "DesovaPier",
        permission: [],
        terminalVisibility: ["RIG"],
        needLogin: true,
        icon: <div style={{ fontSize: "14px" }}><IconeGenerico icone="boxes" tamanho="lg" className="icon"  /></div>,
        itens:[
          {
            tag: "DesovaPier",
            path: "/desova-pier",
            component: DesovaPier,
            needLogin: true,
            onSideBar: false,
            terminalVisibility: ["RIG"],
          },
        ]
      },
      {
        separator: true,
        label: "Consultas",
        tag: "Consultas",
        permission: [],
        needLogin: true,
        icon: <div style={{ fontSize: "12px" }}><IconeGenerico icone="chalkboard" tamanho="lg" className="icon"  /></div>,
        itens: [
          {
            label: "Booking",
            tag: "ConsultaBooking",
            path: "/booking",
            component: Booking,
            needLogin: true,
            onSideBar: true
          },
          {
            label: "Containers",
            tag: "ConsultaContainer",
            path: "/containers",
            component: Containers,
            needLogin: false,
            onSideBar: true
          },
          {
            path: "/containers-detalhes/:id",
            tag: "ConsultaContainer",
            component: ContainersDetalhes,
            needLogin: false,
            onSideBar: false
          },
          {
            label: !process.env.rig ? "Movimentação de Containers" : "Movimentação",
            tag: "Movimentacao",
            path: "/movimentacao",
            component: Movimentacao,
            needLogin: true,
            onSideBar: true
          },
          {
            label: "Sailing Breakdown",
            tag: "ConsultaSailling",
            path: "/sailing-breakdown",
            component: SailingBreakdown,
            needLogin: true,
            onSideBar: true
          },
          {
            label: "Notas Fiscais",
            tag: "NotasFiscaisAde",
            path: "/agendamento-nota-fiscal",
            component: AgendamentoNotaFiscal,
            terminalVisibility: ["RIG"],
            needLogin: true,
            onSideBar: true
          },
          {
            label: "Nota Fiscal",
            tag: "NotasFiscaisAde",
            path: "/agendamento-nota-fiscal/cadastro",
            component: NotaFiscalCadastrar,
            needLogin: true,
            onSideBar: false
          },
          {
            label: "Editar Nota Fiscal",
            tag: "NotasFiscaisAde",
            path: "/agendamento-nota-fiscal/editar/:id",
            component: NotaFiscalCadastrar,
            needLogin: true,
            onSideBar: false
          },
          {
            label: "Duplicar Nota Fiscal",
            tag: "NotasFiscaisAde",
            path: "/agendamento-nota-fiscal/duplicar/:id",
            component: NotaFiscalCadastrar,
            needLogin: true,
            onSideBar: false
          },
          {
            label: "Consulta EDI NF",
            tag: "ConsultaEdiNf",
            path: "/consulta-edi-nf",
            component: ConsultaEdiNf,
            needLogin: true,
            onSideBar: false
          },
          {
            label: "Consulta de Veículos",
            tag: "ConsultaVeiculos",
            path: "/consulta-veiculos",
            component: Veiculos,
            onSideBar: true,
            terminalVisibility: ["SSA"]
          },
          {
            label: "Controle de Carga - Descarga",
            tag: "CargasDesdobradas",
            path: "/controle-estoque",
            component: ControleEstoque,
            onSideBar: true
          },
          {
            label: "Consulta Agendamento - Depot",
            tag: "AgendDepotTriagem",
            path: "/triagem-depot",
            component: TriagemDepot,
            onSideBar: true
          }
        ]
      },
      {
        separator: true,
        label: !process.env.rig ? "Agendamento de Container" : "Agendamento",
        tag: "AgendamentoCntr",
        permission: [],
        needLogin: process.env.rig ? false : true,
        icon: <div style={{ fontSize: "12px" }}><IconeGenerico icone="money-check" tamanho="lg" className="icon"  /></div>,
        itens: [
          {
            label: !process.env.rig ? "Agendamento" : "Container",
            tag: "AgendamentoContainer",
            path: "/agendamento-container",
            component: Agendamento,
            needLogin: true,
            onSideBar: true
          },
          {
            tag: "AgendamentoContainer",
            path: "/agendamento-container/cadastro",
            component: AgendamentoCadastrar,
            needLogin: true,
            onSideBar: false
          },
          {
            tag: "AgendamentoContainer",
            path: "/agendamento-container/cadastro/:id",
            component: AgendamentoCadastrar,
            needLogin: true,
            onSideBar: false
          },
          {
            label: "Informações Gate",
            tag: "AgendamentoContainer",
            path: "/agendamento-dashboard",
            component: AgendamentoDashboard,
            needLogin: process.env.rig ? false : true, //necessita estar false para SSA
            onSideBar: true
          },
          {
            label: "Depot - Unidades Liberadas Armador",
            tag: "AgendDepotLiberarUnidades",
            path: "/agendamento-unidades-liberadas",
            component: UnidadesLiberadasArmador,
            terminalVisibility: ["SSA"],
            onSideBar: true
          },
          {
            label: "Triagem Depot",
            tag: "AgendDepotTriagem",
            path: "/agendamento-triagem-depot",
            component: Triagem,
            onSideBar: true,
            terminalVisibility: ["SSA"]
          },
          {
            label: "Notas Fiscais",
            tag: "NotasFiscaisAde",
            path: "/agendamento-nota-fiscal",
            component: AgendamentoNotaFiscal,
            terminalVisibility: ["SSA"],
            onSideBar: true
          },
          {
            label: "Entrada Antecipada",
            tag: "EntradaAntecipada",
            path: "/solicitacao-entrada-antecipada",
            component: EntradaAntecipada,
            onSideBar: true,
            terminalVisibility: ["SSA"]
          },
          {
            label: "Veículos Aguardando CDTA",
            tag: "ConsultaVeiculos",
            path: "/veiculos-cdta",
            component: VeiculosCDTA,
            onSideBar: true,
            terminalVisibility: ["SSA"]
          },
          {
            label: "Veículos na Triagem",
            tag: "ConsultaVeiculos",
            path: "/agendamento-consulta-veiculos",
            component: ConsultaVeiculos,
            onSideBar: true,
            terminalVisibility: ["SSA"]
          }
        ]
      },
      {
        separator: true,
        label: "Agendamento de Serviços",
        tag: "AgendamentoServ",
        permission: [],
        terminalVisibility: ["SSA"],
        needLogin: true,
        icon: <div style={{ fontSize: "14px" }}><IconeGenerico icone="calendar-alt" tamanho="lg" className="icon"  /></div>,
        itens: [
          {
            label: "Análise Crítica",
            tag: "AnaliseCritica",
            path: "/analise-critica",
            component: AnaliseCritica,
            onSideBar: true
          },
          {
            label: "Agendamento de Serviços",
            tag: "AgendamentoServico",
            path: "/agendamento-servicos",
            component: AgServicos,
            onSideBar: true
          },
          // {
          //   label: "Agendamento de Serviços Total",
          //   tag: "AgendamentoServico",
          //   path: "/agendamento-servicos-total",
          //   component: AgServicosTotal,
          //   onSideBar: true
          // },
          {
            label: "Acompanhamento de Serviços",
            tag: "AcompanhamentoServicos",
            path: "/acompanhamento-servicos",
            component: AcompanhamentoServicos,
            onSideBar: true
          }
        ]
      },
      {       
        separator: true,
        label: "Carga Geral",
        tag: "CargaGeral",
        permission: [],
        needLogin: true,
        icon: <div style={{ fontSize: "14px" }}><IconeGenerico icone="truck" tamanho="lg" className="icon"  /></div>,
        itens: [
          {
            label: "Agendamento",
            tag: "CargaGeralAgend",
            path: "/carga-geral",
            component: CargaGeral,
            onSideBar: true
          },
          {
            label: "Acompanhamento",
            tag: "CargaGeralAcompanhamento",
            path: "/carga-geral-acompanhamento",
            component: CargaGeralAcompanhamento,
            onSideBar: true
          }
        ]
      },
      {
        separator: true,
        label: "Acompanhamento de Processo",
        tag: "AcompanhamentoProcesso",
        permission: [],
        needLogin: true,
        icon: <div style={{ fontSize: "14px" }}><IconeGenerico icone="clipboard-check" tamanho="lg" className="icon"  /></div>,
        itens: [
          {
            tag: "AcompanhamentoProcesso",
            path: "/acompanhamento-processo",
            component: Acompanhamento,
            needLogin: true,
            onSideBar: false
          }
        ]
      },
      {
        separator: true,
        label: "Associar Booking Depot",
        tag: "AssociarDepotBooking",
        permission: [],
        terminalVisibility: ["SSA"],
        needLogin: true,
        icon: <div style={{ fontSize: "14px" }}><IconeGenerico icone="exchange-alt" tamanho="lg" className="icon"  /></div>,
        itens: [
          {
            tag: "AssociarDepotBooking",
            path: "/booking-depot",
            component: BookingDepot,
            onSideBar: false
          }
        ]
      },
      {
        separator: true,
        label: "Liberação Documental",
        tag: "LiberacaoDocumental",
        permission: [],
        needLogin: true,
        terminalVisibility: ["SSA"],
        icon: <div style={{ fontSize: "14px" }}><IconeGenerico icone="book" tamanho="lg" className="icon"  /></div>,
        itens: [
          {
            label: "Importação",
            tag: "LiberacaoImportacao",
            path: "/liberacoes-importacao",
            terminalVisibility: ["SSA"],
            component: Importacao,
            onSideBar: true
          },
          {
            tag: "LiberacaoImportacao",
            path: "/liberacoes-importacao/detalhes/:id",
            component: ImportacaoDetalhes,
            terminalVisibility: ["SSA"],
            onSideBar: false
          },
          {
            label: "Cabotagem",
            tag: "LiberacaoCabotagem",
            path: "/liberacoes-cabotagem",
            terminalVisibility: ["SSA"],
            component: Cabotagem,
            onSideBar: true
          }
        ]
      },
      {
        separator: true,
        label: "Controle de Entrepostagem",
        tag: "ControleEntrepostagem",
        permission: [],
        needLogin: true,
        terminalVisibility: ["SSA"],
        icon: <div style={{ fontSize: "12px" }}><IconeGenerico icone="chalkboard" tamanho="lg" className="icon" /></div>,
        itens: [
          {
            label: "Relatório Sintético",
            tag: "ControleEntrepostagem",
            path: "/entrepostagem-sintetico",
            component: RelatorioSintetico,
            terminalVisibility: ["SSA"],
            onSideBar: true
          },
          {
            label: "Relatório Analítico",
            tag: "ControleEntrepostagem",
            path: "/entrepostagem-analitico",
            component: RelatorioAnalitico,
            terminalVisibility: ["SSA"],
            onSideBar: true
          }
        ]
      },
      {
        separador: true,
        label: "Bloqueio Desdobramento BL",
        tag: "BloqueioDesdobramentoBL",
        permission: [],
        terminalVisibility: ["RIG"],
        needLogin: true,
        icon: <div style={{ fontSize: "12px" }}><IconeGenerico icone="th-large" tamanho="lg" className="icon"  /></div>,
        itens: [
          {
            tag: "BloqueioDesdobramentoBL",
            path: "/bloqueio-bl",
            component: BloqueioBl,
            terminalVisibility: ["RIG"],
            needLogin: true,
            onSideBar: false
          }
        ]
      },
      {
        separator: true,
        label: "OS Web",
        tag: "OsWeb",
        permission: [],
        terminalVisibility: ["RIG"],
        needLogin: true,
        icon: <div style={{ fontSize: "14px" }}><IconeGenerico icone="calendar-alt" tamanho="lg" className="icon"  /></div>,
        itens: [
          {
            tag: "OsWeb",
            path: "/os-web",
            component: Osweb,
            needLogin: true,
            onSideBar: false
          }
        ]
      },
      {
        separator: true,
        label: "Direcionamento",
        tag: "Direcionamento",
        permission: [],
        terminalVisibility: ["SSA"],
        needLogin: true,
        icon: <div style={{ fontSize: "14px" }}><IconeGenerico icone="map-signs" tamanho="lg" className="icon"  /></div>,
        itens: [
          {
            label: "Tecon",
            tag: "DirecionamentoTecon",
            path: "/direcionamento-tecon",
            component: DirecionamentoTecon,
            onSideBar: true
          },
          {
            label: "Recinto",
            tag: "DirecionamentoRecinto",
            path: "/direcionamento-recinto",
            component: DirecionamentoRecinto,
            onSideBar: true
          }
        ]
      },
      {
        separator: true,
        label: "VGM",
        tag: "AgendamentoVgm",
        permission: [],
        terminalVisibility: ["RIG"],
        needLogin: true,
        icon: <div style={{ fontSize: "12px" }}><IconeGenerico icone="truck-moving" tamanho="lg" className="icon"  /></div>,
        itens: [
          {
            tag: "AgendamentoVgm",
            path: "/vgm",
            component: AgendVgm,
            needLogin: true,
            onSideBar: false            
          }
        ]
      },
      {
        separator: true,
        label: "Módulo Faturamento",
        tag: "Faturamento",
        permission: [],
        needLogin: true,
        icon: <div style={{ fontSize: "14px" }}><IconeGenerico icone="calculator" tamanho="lg" className="icon"  /></div>,
        itens: [
          {
            label: "Nota Fiscal Tecon",
            tag: "ConsultaProtocoloEletronico",
            path: "/faturamento-notafiscal",
            component: NotaFiscalFaturamento,
            needLogin: true,
            onSideBar: true
          },
          {
            label: "Orçamentos",
            tag: "OrcamentoWeb",
            path: "/consulta-orcamentos",
            component: ConsultaOrcamento,
            needLogin: true,
            onSideBar: true
          },
          {
            terminalVisibility: ["RIG"],
            label: "Alterar Cliente DTA Pátio e DTC",
            tag: "AlteracaoDtaPatioDtc",
            path: "/altera-dta-dtc",
            component: AlteraDtaDtc,
            needLogin: true,
            onSideBar: true
          }
        ]
      },
      {
        separator: true,
        label: "Avisos",
        tag: "Notices",
        permission: [],
        needLogin: true,
        icon: <div style={{ fontSize: "14px" }}><IconeGenerico icone="exclamation" tamanho="lg" className="icon"  /></div>,
        itens: [
          {
            tag: "Notices",
            path: "/notices",
            component: Notices,
            needLogin: true,
            onSideBar: false
          },
          {
            tag: "Notices",
            path: "/notices/cadastro/:id?",
            component: FormNotice,
            needLogin: true,
            onSideBar: false
          }
        ]
      }
    ];
  }
}
export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js